import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import { PeriodType } from '../watermonitoring/constants/measurementConfig';

const ExportDiagramButton = ({ chartRef, measurements, period, chartName = 'Dijagram' }) => {
  const getFileName = () => {
    if (!measurements || measurements.length === 0) {
      return `${chartName}.png`;
    }

    const sortedMeasurements = [...measurements].sort((a, b) => 
      new Date(a.time) - new Date(b.time)
    );

    const firstDate = new Date(sortedMeasurements[0].time);
    const lastDate = new Date(sortedMeasurements[sortedMeasurements.length - 1].time);

    const formatDate = (date) => format(date, 'dd.MM.yyyy');

    if (period === PeriodType.DAY) {
      return `${chartName}-${formatDate(firstDate)}.png`;
    } else {
      return `${chartName}-${formatDate(firstDate)}-${formatDate(lastDate)}.png`;
    }
  };

  const handleExport = () => {
    const chart = chartRef.current;
    if (chart) {
      const url = chart.toBase64Image();
      const link = document.createElement('a');
      link.download = getFileName();
      link.href = url;
      link.click();
    }
  };

  return (
    <Tooltip title="Preuzmi dijagram" arrow>
      <IconButton 
        onClick={handleExport} 
        size="small" 
        sx={{ color: "#21538f" }}
      >
        <FileDownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ExportDiagramButton;